<template>
	<div id="app" 
		:class="[
			'app',
			{'center_app': $route.path.indexOf('center')>=0 || $route.path.indexOf('service')>=0 }
		]"
		v-loading.fullscreen.lock="loading"
		element-loading-text="Loading"
		element-loading-spinner="el-icon-loading"
		element-loading-background="rgba(0, 0, 0, 0.8)">
		<!-- 页头 -->
		<header-body></header-body>
		<!-- 主体 -->
		<keep-alive v-if="$route.name != 'pdetail'">
			<router-view></router-view>
		</keep-alive>
		<router-view v-else></router-view>
		<!-- 页脚 -->
		<footer-body v-if="$route.path.indexOf('center')<0"></footer-body>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
	computed: mapState({
		loading: state => state.loading, // 加载动画
	}),
	components: {
		headerBody: () => import('@/components/headerBody'),
		footerBody: () => import('@/components/footerBody')
	},
	methods: {
		...mapMutations([
			"setSessionLogin",
			"clearLogin"
		]),
		...mapActions([
			"getCurrency",
			"getTitle",
			"getPriceDisplay"
		]),
		shareSession(){
			window.addEventListener('storage', (event) => {
				if (event.key == 'token') { // 当前标签页
					// 已存在的标签页会收到这个事件
					localStorage.setItem('sessionStorage', JSON.stringify(sessionStorage));
					localStorage.removeItem('sessionStorage');
				
				} else if (event.key == 'sessionStorage') { // 新开标签页
					// 新开启的标签页会收到这个事件
					let data = JSON.parse(event.newValue);
					for (let key in data) {
						if(key === "vuex"){
							this.setSessionLogin(JSON.parse(data[key]).user);
							this.$router.go(0);
						}
					}
				} else if (event.key == "signOut"){ // 注销事件
					this.clearLogin();
					this.$router.go(0);
				}
			});
		}
	},
	beforeCreate() {
		// 注销加载动画
		let loading = document.getElementById("loader-wrapper");
		if(loading != null){
			document.body.removeChild(loading);
		}
		// 判断是否存在多语言
		let _lang = localStorage.lang;
		if(!_lang){
			localStorage.lang="cn";
		}
	},
	//标题
	created() {
		this.getTitle(0).then( res => {
			// document.title = res
			document.title = "新極速"
			// document.title = "BlossomPower"
		});
		this.getCurrency();
		this.getPriceDisplay();
		if (!sessionStorage.length) {
			localStorage.setItem('token', Date.now());
		};
		this.shareSession();
	},
};
</script>


<style>
/*重置属性*/
body,ol,ul,h1,h2,h3,h4,h5,h6,p,th,td,dl,dd,form,fieldset,legend,input,textarea,select{
	margin:0;
	padding:0
}
*{
	font-family:"微软雅黑"; 
	font-size:14px; 
	padding:0; 
	margin:0;
}
body{
	font:14px "微软雅黑","Arial Narrow",HELVETICA;
	background:#fff;
	-webkit-text-size-adjust:100%
}
img{
	border:0;
	vertical-align:middle
}
a,a:hover,a:active,a:visited,a:link {
  	text-decoration: none !important;
}
a:focus {
	color: #333;
}
ul {
  	list-style: none;
	margin: 0
}
.app {
	min-height: 100%;
	padding-top: 151px;
	background-color: #f5f5f5;
	min-width: 1200px;
}
.el-upload__input{
	display: none !important;
}
/* 个人中心路由时的app样式 */
.center_app{
	padding-top: 50px;
}
/* element-ui 优化 */
.el-input-number i{
  font-size: small;
}
/* 表格滚动条优化 */
.el-table__body-wrapper::-webkit-scrollbar{
    width: 5px;
    height: 5px;
    background-color: #ddd;
}
.el-table__body-wrapper::-webkit-scrollbar-thumb{
    /* background-color: rgba(0, 0, 0, 0.5); */
	background-color: rgba(253, 100, 31, 1.0);
    border-radius: 5px;
}
/*1199px以下宽度container为1170px*/
@media (max-width: 1199px) {
	.container {
		width: 1170px;
	}
}
</style>
